<template>
  <member-form/>
</template>

<script>
import MemberForm from '@/components/members/EditForm.vue'

export default {
  name: 'MemberFormEditPage',
  components: {
    MemberForm
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/members/EditForm.vue